export function ProductDescriptionCollapseInit() {
    const productDescriptionQuery = '.c-product-description';
    const productDescriptionWrapperQuery = '.c-product-description_wrapper';
    const buttonQuery = '#product-description-less-more-button';

    /**
     * @type
     */
    const showHideButton = document.querySelector(buttonQuery);

    /**
     * @type {null | HTMLDivElement}
     */
    const productDescription = document.querySelector(productDescriptionQuery);

    /**
     * @type {null | HTMLDivElement}
     */
    const productDescriptionWrapper = document.querySelector(productDescriptionWrapperQuery);

    if(showHideButton && productDescription && productDescriptionWrapper){

        showHideButton.addEventListener('click', (el) => {
            if(productDescriptionWrapper.classList.contains('expanded')) {
                productDescriptionWrapper.classList.remove('expanded');
                el.target.innerText = 'Zobacz opis raportu';
                productDescriptionWrapper.style.height='';
            } else {
                productDescriptionWrapper.classList.add('expanded');
                productDescriptionWrapper.style.height= productDescription.clientHeight + 'px';
                el.target.innerText = 'Zwiń opis raportu';
            }
        })
    }

}
